<template>
    <div id="app">
        <header>
            <div class="tw-container tw-flex tw-items-center tw-justify-between">
                <div class="lg:tw-flex tw-text-center tw-items-center tw-justify-center">
                    <img class="logo-header" src="~@/assets/img/logo.png" alt="eFuturo">
                    <p>Ajudamos a construir o seu futuro!</p>
                </div>
                <div class="tw-flex tw-items-center tw-gap-4">
                    <img class="certification" src="~@/assets/img/logo_dgert.svg" alt="Certificado DGERT">
                    <img class="certification" src="~@/assets/img/shield.jpg" alt="Enquadramento no mercado de trabalho">
                </div>
            </div>
        </header>

        <!-- This will be replaced by the view defined in the router -->
        <router-view></router-view>

        <section class="vantagens">
            <div class="tw-container tw-grid tw-grid-cols-1 lg:tw-grid-cols-3">
                <div class="tw-text-center tw-items-center tw-justify-center">
                    <img src="~@/assets/img/formacao_personalizada.svg" alt="Formação Personalizada">
                    <h2>Formação Personalizada</h2>
                    <p>feita ao seu ritmo acompanhada presencialmente ou pela plataforma por nossa equipa de formadores</p>
                </div>
                <div class="tw-text-center tw-items-center tw-justify-center tw-mt-8 lg:tw-mt-0">
                    <img src="~@/assets/img/flexibilidade_horarios.svg" alt="Flexibilidade de Horários">
                    <h2>flexibilidade de horários</h2>
                    <p>Vários Horários disponíveis:<br>Laboral, Pós-Laboral, Misto</p>
                </div>
                <div class="tw-text-center tw-items-center tw-justify-center tw-mt-8 lg:tw-mt-0">
                    <img src="~@/assets/img/empregabilidade.svg" alt="80% Empregabilidade">
                    <h2>80% Empregabilidade</h2>
                    <p>A nossa rede de parceiros em Portugal e na Europa garante-nos uma elevada taxa de enquadramento profissional</p>
                </div>
            </div>
        </section>

        <section class="testemunhos tw-container">
            <div class="glide section__slider tw-relative">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        <li class="glide__slide slide ">
                            <h2>Francineide Madureira</h2>
                            <!-- <h3>Restaurante e Bar</h3> -->
                            <p>“Agradeço imenso pela vossa colaboração e tempo de serem atenciosos com os formandos. Sou grata pela atenção que têm dado á minha pessoa. Tenho aprendido muito com o curso, pois foi muito eficaz para mim. Agradeço também pela formadora Soraia pela dedicação de ensina-lo. Muitíssimo obrigada de coração. Abraços!”</p>
                        </li>
                        <li class="glide__slide slide ">
                            <h2>Sofia Ali</h2>
                            <!-- <h3>Técnico de Auxiliar de Geriatria</h3> -->
                            <p>“Todo o percurso foi bem sucedido. Gostei imenso de ter frequentado a formação na eFuturo, pois são todos bastante atenciosos e simpáticos, e como se diz, 'a simpatia fez a casa'. Só tenho a agradecer por tudo e pela brevidade com que resolvem tudo. Já na fase final, de estágio, que espero que corra bem também, com todas as metas alcançadas. Obrigada uma vez mais.”</p>
                        </li>
                        <li class="glide__slide slide ">
                            <h2>Maria Isabel Santos</h2>
                            <!-- <h3>Assistente Operacional de Saúde</h3> -->
                            <p>“Considero a minha passagem pela eFuturo, gratificante pela atenção que particularmente me foi dada, e pelas colegas em geral. Pela formação em si, considero-a de muita importância, pelo cuidado e empenho profissional, que a formadora Soraia me deu. Às pessoas com quem lidei na eFuturo, agradeço a forma como fui considerada.”</p>
                        </li>
                        <li class="glide__slide slide ">
                            <h2>Natacha Bhanji</h2>
                            <!-- <h3>Governanta de Hotel</h3> -->
                            <p>“Gostei muito de ter realizado este curso na eFuturo. A equipa é fantástica, sempre disponível para esclarecer todas as questões e dúvidas. Aconselho vivamente a realização do curso de Assistente Operacional de Saúde. A formadora mostra boa vontade de ensinar e sentimos que aprendemos mesmo. Obrigada.”</p>
                        </li>
                        <li class="glide__slide slide ">
                            <h2>Inês Marmelo</h2>
                            <!-- <h3>Receção de Hotel</h3> -->
                            <p>"A eFuturo ajudou-me muito a perceber o que queria… Vejo na eFuturo uma empresa séria. Esta proporciona aos formandos fazerem formações e, no meu caso, auxiliaram-me a escolher o que seria melhor para mim, apresentaram-me os cursos e os seus conteúdos e decidi optar por AOS. Gostei muito dos conteúdos de todos os módulos e dos respetivos workshops. Recomendo a eFuturo a outros formandos.”</p>
                        </li>
                        <li class="glide__slide slide ">
                            <h2>Albertina Afonso</h2>
                            <!-- <h3>Receção de Hotel</h3> -->
                            <p>"Na minha opinião a eFuturo foi a melhor opção que tive até à data e não me arrependo. Foi e é uma porta aberta para o meu futuro, uma busca de novas oportunidades. Foi pela eFuturo que adquiri novos conhecimentos, cresci como pessoa e conheci pessoas extraordinárias. Adorei frequentar este curso nas vossas instalações e recomenda-se. Obrigada por fazer parte desta família que é a eFuturo.”</p>
                        </li>
                    </ul>
                    <div class="glide__bullets" data-glide-el="controls[nav]">
                        <button class="glide__bullet" data-glide-dir="=0"></button>
                        <button class="glide__bullet" data-glide-dir="=1"></button>
                        <button class="glide__bullet" data-glide-dir="=2"></button>
                        <button class="glide__bullet" data-glide-dir="=3"></button>
                        <button class="glide__bullet" data-glide-dir="=4"></button>
                        <button class="glide__bullet" data-glide-dir="=5"></button>
                    </div>
                    <div class="glide__arrows" data-glide-el="controls">
                        <button class="btn-prev" data-glide-dir="<"></button>
                        <button class="btn-next" data-glide-dir=">"></button>
                    </div>
                </div>
            </div>
        </section>

        <footer>
            <div class="tw-container tw-flex tw-items-center tw-justify-between">
                <p><a href="#" @click.prevent="$store.state.modal.terms = true">Política de Privacidade</a></p>
                <img src="~@/assets/img/certificado_dgert.svg" alt="Certificado DGERT">
            </div>
        </footer>

        <ModalContainer>
            <Terms/>
        </ModalContainer>

        <KwPixel v-if="$store.state.formSuccess"/>
    </div>
</template>

<script>
import KwPixel from '@/components/KwPixel.vue';
import ModalContainer from '@/components/ModalContainer.vue';
import Terms from '@/components/Terms.vue';
import Glide, { Swipe, Autoplay, Controls } from '@glidejs/glide/dist/glide.modular.esm';

export default {
    components: {
        KwPixel,
        ModalContainer,
        Terms,
    },
    mounted() {
        window.cmp_setlang = document.documentElement.lang;
        new Glide('.section__slider', {
            autoplay: 5000,
            gap: 0,
        }).mount({ Swipe, Autoplay, Controls });

        const data = {
            url: window.location.hostname,
            pubid: this.pubid,
            utm_source: this.$route.query.utm_source,
            utm_campaign: this.$route.query.utm_campaign,
            utm_medium: this.$route.query.utm_medium,
            utm_content: this.$route.query.utm_content,
            utm_term: this.$route.query.utm_term,
            ua_device: this.$store.state.ua_device,
            ua_browser: this.$store.state.ua_browser,
            ua_os: this.$store.state.ua_os,
        };
        axios.post(`${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/trk`, data)
            .then((response) => {
                this.$store.state.token = response.data.token;
            })
            .catch((error) => console.log(error));
        axios
            .get('https://kw-lp-info.s3.eu-west-1.amazonaws.com/eFuturo/courses-list.json')
            .then((response) => {
                this.$store.state.courseList = response.data;
            });
    },
};
</script>
<style>

</style>
